<template>
  <div class="service-order">
    <ServieOrderTable />
  </div>
</template>

<script>
import ServieOrderTable from '../components/serviceOrder/ServiceOrderTable/ServiceOrdersTable.vue'
export default {
  components: {
    ServieOrderTable,
  },
}
</script>

<style lang="scss" scoped></style>
